import React, { useContext } from "react";
import "../stylesheet/prescription.css";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { getAllBilling } from "../Utils/localStore";
import Topnav from "../components/others/Topnav";
import BillingCards from "../components/billings/BillingCards";
import ToastContext from "../context/toasterContex";
import MenuButtons from "../components/billings/MenuButtons";
import AllInvoiceReport from "./AllInvoices";
const Billing = () => {
  const [showActivities, setShowActivities] = useState(true);
  const { toast } = useContext(ToastContext);
  const navigate = useNavigate();
  const [allBillingss, setAllBillingss] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const getLocalData = async () => {
    let response;
    try {
      await getAllBilling().then((resp) => (response = resp));
      console.log({ response });
      return setAllBillingss(response);
    } catch (error) {
      toast.error(error, { position: toast.POSITION.TOP_CENTER });
      throw new Error(error);
    }
  };
  const handleButtonClick = () => {
    setShowActivities(!showActivities);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    getLocalData();
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  let countActive = allBillingss.filter(
    (item) => item.status === "Paid"
  ).length;
  let countInactive = allBillingss.filter(
    (item) => item.status === "Unpaid" || !item.status
  ).length;
  const billings = [
    {
      percent: null,
      value: allBillingss.length || 0,
      type: "All Billing",
      src: "all-billing",
      data: [0, 20, 5, 35, 25, 45],
    },
    {
      percent: null,
      value: countActive || 0,
      type: "Paid Billing",
      src: "all-billing",
      data: [0, 18, 10, 35, 15, 50, 25],
    },
    {
      percent: null,
      value: countInactive || 0,
      type: "Unpaid Billing",
      src: "all-billing",
      data: [0, 20, 5, 35, 25, 45],
    },
  ];

  return (
    <div className="prescription_body">
      <Topnav />
      <div className="prescription">
        <MenuButtons />

        <BillingCards value={allBillingss} eventSourced={billings} />

        <div className="view_button">
          <button onClick={handleButtonClick}>View custom report</button>
        </div>
        <div className="recent">
          <div className="header_act">
            <h2>Recent Activities</h2>
            <Link to="/billings/all_invoices">
              <p>View All</p>
            </Link>
          </div>
          <AllInvoiceReport recent={7} />
        </div>
      </div>
    </div>
  );
};

export default Billing;
